<template>
  <div class="flex flex-col items-start">
    <Card
      class="w-full max-w-2xl border border-surface-200"
      :pt="{ body: { class: 'p-3' } }"
      data-testid="authored-document-card"
    >
      <template #content>
        <div class="flex items-center gap-3">
          <i class="pi pi-file-edit text-primary" />
          <div class="flex-1 min-w-0">
            <div class="text-sm font-medium truncate">
              {{ title || t('authoredDocuments.library.untitled') }}
            </div>
            <div class="text-xs text-surface-500">
              {{ t('chat.authored_document.created') }}
            </div>
          </div>
          <Button
            :label="t('chat.authored_document.open')"
            size="small"
            outlined
            @click="emit('open', docId)"
          />
        </div>
      </template>
    </Card>
  </div>
</template>

<script setup lang="ts">
/**
 * The chat's card for a document the assistant just opened (MYAC-1162).
 *
 * Deliberately one line and one button. The document itself is not summarised here:
 * a long report inside a transcript is the problem this whole feature exists to
 * solve, so the card says a document now exists and gets out of the way.
 *
 * CREATION ONLY. Edits render nothing in the timeline — their feedback is the live
 * panel and the bot's own text. A card per edit would bury the report under its own
 * changelog, and the store's getter is what enforces it.
 *
 * It emits rather than navigating: on a full-page chat the caller opens the side
 * panel, and in the narrow docked panel it sends the user to the document page.
 */
import { useI18n } from 'vue-i18n'
import Button from 'primevue/button'
import Card from 'primevue/card'

defineProps<{
  docId: string
  title: string
}>()

const emit = defineEmits<{ open: [docId: string] }>()

const { t } = useI18n()
</script>
